import React,    { useState, useEffect ,  } from 'react' ;


import { Form, Button, Row, Col } from 'react-bootstrap'

import  {useDispatch, useSelector} from 'react-redux'



import Message from '../../Message/Message'

import Loader from '../../Loader/Loader'

import Meta from '../../Helmet/Meta'

import FormContainer from '../../FormContainer/FormContainer' ;

import  { register }  from '../../../actions/newsflashActions' ;


import './list.css';

const Newsflashadd = ({ location, history }) => {
const dispatch = useDispatch()
const [titre, setTitre] = useState('') 
const [text, setText] = useState('') 
const [link, setLink] = useState('');
const [message] = useState(null)
const newsflashRegister = useSelector(state => state.newsflashRegister)
const { loading, newsflashInfo, error } = newsflashRegister

//const redirect = location.search ? location.search.split('=')[1] : '/'
//useEffect(() => {
//        if (newsflashInfo) {
//            history.push(redirect)
//        }
//    }, [newsflashInfo, history, redirect])

////////////

const handleFileChange = (e) => {
    const link = e.target.files[0];
    if (link) {
      // Process the selected file as needed
      console.log('Selected File:', link.name);
      // You can set the file name or path to the state or perform other operations.
      setLink(link.name);
    }
  };


  const submitHandler = (e) => {
        e.preventDefault()
        dispatch(register(titre, text, link ));
        alert('Newsflash added successfully');
        history.push('/newsflashlist');
    }

    
    const goBack = () => {
        history.goBack(); // This function navigates back to the previous page
      };



    return (
       <div className="main"  fluid>
        <FormContainer >
            <Meta
                title=" | ADD News-flash"
            />
             <br />
            <br /> <br />
            <br />
          
           <h1 > Ajouter un News-flash </h1>
            <Button  type="submit"  style={{ float: 'right',  backgroundColor: 'red'  }} onClick={goBack}>Retourner</Button>
            <br />
            <br />

            {message && <Message variant='danger'>{message}</Message>}
            {error && <Message variant='danger'>{error}</Message>}
            {loading && <Loader />}
            <Form onSubmit={submitHandler}>
            <Row>
                    <Col md={10}>
                        <Form.Group controlId='titre'>
                            <Form.Label> Titre <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Form.Control
                                type="titre"
                                placeholder="Entrez votre titre "
                                value={titre}
                                required
                                onChange={(e) => setTitre(e.target.value)}
                            ></Form.Control>
                        </Form.Group>

                        <Form.Group controlId='text'>
                            <Form.Label> Description <span style={{ color: 'red' }}>*</span></Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Entrez votre text "
                                value={text}
                                required
                                onChange={(e) => setText(e.target.value)}
                            ></Form.Control>
                        </Form.Group>
                  
          <Form.Group controlId="link">
          <Form.Label>Select a file <span style={{ color: 'red' }}>*</span></Form.Label>
    

                      <Form.Control
                        type="file"
                        onChange={(e) => handleFileChange(e)}
                      />
                    </Form.Group>
                    
        
                    <br />  

                        <Button type="submit"  style={{  backgroundColor: 'red'  }} > 
                        
                        Ajouter </Button>
                    </Col>
                </Row>
                <br />
                <br />  <br />
            </Form>
            
        </FormContainer>
        </div>
    )
}

export default Newsflashadd
